import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import AddExperienceModal from './add-experience-modal'
import Skeleton from 'react-loading-skeleton'
import {industryOptions} from '../../../../core/_constants'
import {NoDataPage} from '../../../resources/components/NoDataPage'
import {useDateFormat} from '../../../../hooks/useDateFormat'

const PersonalExperience = ({
  isActiveModal,
  setIsActiveModal,
  handleIsActiveModal,
  personalExp,
  setPersonalExp,
  formik,
  loading,
  founderDetails,
}: any) => {
  const {formatMessage} = useIntl()
  const [currentExp, setCurrentExp] = useState<any>(null)
  const {getDateValue} = useDateFormat()

  useEffect(() => {
    if (!founderDetails && personalExp) {
      const mappedProfessionalExp = personalExp.map((exp: any) => {
        const mappedExp: any = {}
        if (exp.companyName) mappedExp.companyName = exp.companyName
        if (exp.industry) mappedExp.industry = parseInt(exp.industry)
        if (exp.startDate) mappedExp.startDate = exp.startDate
        if (exp.isInCurrentCompany) mappedExp.isInCurrentCompany = exp.isInCurrentCompany
        if (exp.endDate) mappedExp.endDate = exp.endDate
        if (exp.title) mappedExp.title = exp.title
        if (exp.location) mappedExp.location = exp.location

        return mappedExp
      })
      formik?.setFieldValue('professionalExperiences', mappedProfessionalExp)
    } else {
      if (personalExp && founderDetails && Array.isArray(personalExp)) {
        const mappedProfessionalExp = personalExp.map((exp: any) => {
          const mappedExp: any = {}
          if (exp.id) mappedExp.id = exp.id
          if (exp.founderPromoterId) mappedExp.founderPromoterId = exp.founderPromoterId
          if (exp.companyName) mappedExp.companyName = exp.companyName
          if (exp.industry) mappedExp.industry = parseInt(exp.industry)
          if (exp.startDate) mappedExp.startDate = exp.startDate
          if (exp.isInCurrentCompany) mappedExp.isInCurrentCompany = exp.isInCurrentCompany
          if (exp.endDate) mappedExp.endDate = exp.endDate
          if (exp.title) mappedExp.title = exp.title
          if (exp.location) mappedExp.location = exp.location

          return mappedExp
        })
        formik?.setFieldValue('professionalExperiences', mappedProfessionalExp)
      }
    }
  }, [personalExp]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleEdit = (experience: any) => {
    setCurrentExp(experience)
    setIsActiveModal(true)
  }

  return (
    <>
      <div className='mb-4'>
        <div className=' d-md-flex justify-content-between align-items-center'>
          <h2 className='font-size-16'>{formatMessage({id: 'Professional Experience'})}</h2>
          <div>
            <button
              className='btn btn-outline-primary py-2 w-100 w-md-100'
              type='button'
              onClick={() => {
                setCurrentExp(null)
                handleIsActiveModal(true)
              }}
            >
              {formatMessage({id: '+ Add Experience'})}
            </button>
          </div>
        </div>
        <div>
          {loading ? (
            <>
              <Skeleton
                height={80}
                width={250}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
              <Skeleton
                height={80}
                width={250}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
              <Skeleton
                height={80}
                width={250}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            </>
          ) : (
            personalExp?.map((pe: any, index: number) => (
              <div className='d-md-flex justify-content-between' key={index}>
                <div className='pt-6 d-flex align-items-center border-0'>
                  <div className='d-flex align-items-center'>
                    <div style={{borderLeft: `3px solid #50CD89`}}>
                      <div className='ps-4'>
                        <div className='d-flex font-weight-500 font-size-16'>
                          {pe?.companyName}
                          <div>
                            <div className={`ms-3 badge py-2 px-6 badge-primary`}>
                              {
                                industryOptions.find(
                                  (option) => option.id === parseInt(pe?.industry)
                                )?.name
                              }
                            </div>
                          </div>
                        </div>
                        <div className='mb-3'>{pe?.title}</div>
                        <div className='color-dates'>
                          <div className='color-dates'>
                            {getDateValue(pe?.startDate)}
                            {' - '}
                            {pe?.endDate ? getDateValue(pe?.endDate) : 'Present'}

                            {pe?.location ? ` | ${pe.location}` : ''}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='pt-6'>
                  <button
                    type='button'
                    className='btn btn-secondary py-2 w-100 w-md-auto'
                    onClick={() => handleEdit(pe)}
                  >
                    {formatMessage({id: 'Edit'})}
                  </button>
                </div>
              </div>
            ))
          )}
          {!loading && personalExp?.length === 0 && <NoDataPage />}
        </div>
      </div>
      <AddExperienceModal
        isActive={isActiveModal}
        setIsActive={setIsActiveModal}
        handleIsActive={handleIsActiveModal}
        setPersonalExp={setPersonalExp}
        currentExp={currentExp}
        founderDetails={founderDetails}
      />
    </>
  )
}

export default PersonalExperience
